import { ICitiesOption, ISelectInputOption } from '@r1-frontend/shared/types/ISelectInputOption';

export const enum EActionTypes {
    SET_SELECTED_CITY = '@AddressInputFields/SET_SELECTED_CITY',
    SET_STREET_TEXT = '@AddressInputFields/SET_STREET_TEXT',
    SET_SELECTED_STREET = '@AddressInputFields/SET_SELECTED_STREET',
    SET_HOUSE_TEXT = '@AddressInputFields/SET_HOUSE_TEXT',
    SET_SELECTED_HOUSE = '@AddressInputFields/SET_SELECTED_HOUSE',
    SET_HOUSE_LIST = '@AddressInputFields/SET_HOUSE_LIST',
    SET_FLAT = '@AddressInputFields/SET_FLAT',
    SET_DATA = '@AddressInputFields/SET_DATA',
}

export type TSetSelectedCity = {
    type: EActionTypes.SET_SELECTED_CITY,
    payload: IAddressFieldsState,
}

export type TSetStreetText = {
    type: EActionTypes.SET_STREET_TEXT,
    payload: Pick<IAddressFieldsState, 'streetText'>,
}

export type TSetSelectedStreet = {
    type: EActionTypes.SET_SELECTED_STREET,
    payload: Pick<IAddressFieldsState, 'selectedStreet' | 'selectedHouse' | 'houseText' | 'flat'>,
}

export type TSetHouseText = {
    type: EActionTypes.SET_HOUSE_TEXT,
    payload: Pick<IAddressFieldsState, 'houseText'>,
}

export type TSetSelectedHouse = {
    type: EActionTypes.SET_SELECTED_HOUSE,
    payload: Pick<IAddressFieldsState, 'selectedHouse' | 'flat'>,
}

export type TSetHouseList = {
    type: EActionTypes.SET_HOUSE_LIST,
    payload: Pick<IAddressFieldsState, 'houseList'>,
}

export type TSetFlat = {
    type: EActionTypes.SET_FLAT,
    payload: Pick<IAddressFieldsState, 'flat'>,
}

export type TSetData = {
    type: EActionTypes.SET_DATA,
    payload: Partial<IAddressFieldsState>,
}

export type TAddressActions = TSetSelectedCity |
    TSetStreetText |
    TSetSelectedStreet |
    TSetHouseText |
    TSetSelectedHouse |
    TSetHouseList |
    TSetFlat |
    TSetData;

export interface IAddressFieldsState {
    selectedCity: ICitiesOption | null,
    streetText: string,
    selectedStreet: ISelectInputOption | null,
    houseText: string,
    selectedHouse: ISelectInputOption | null,
    houseList: ISelectInputOption[],
    flat: string,
}

export const addressFieldsReducer = (state: IAddressFieldsState, action: TAddressActions): IAddressFieldsState => {
    switch (action.type) {
        case EActionTypes.SET_SELECTED_CITY:
        case EActionTypes.SET_STREET_TEXT:
        case EActionTypes.SET_SELECTED_STREET:
        case EActionTypes.SET_HOUSE_TEXT:
        case EActionTypes.SET_SELECTED_HOUSE:
        case EActionTypes.SET_HOUSE_LIST:
        case EActionTypes.SET_FLAT:
        case EActionTypes.SET_DATA: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};

interface IProps {
    initCity?: ICitiesOption | null,
    initStreet?: ISelectInputOption | null,
    initHouse?: ISelectInputOption | null,
    initFlat?: string,
}

export const getInitialState = ({
    initCity,
    initStreet,
    initHouse,
    initFlat,
}: IProps): IAddressFieldsState => ({
    selectedCity: initCity || null,
    streetText: '',
    selectedStreet: initStreet || null,
    houseText: '',
    selectedHouse: initHouse || null,
    houseList: [],
    flat: initFlat || '',
});
